import { requestGet, requestPost, requestFormPost } from '@/common/request';

export default {
  // 商品策略列表-日常活动
  async wareGoodsStrategyList(data) {
    return await requestGet('/ware/goodsStrategyList', data);
  },

  // 素材维护消息触达（确认触达）
  // https://cf.jd.com/pages/viewpage.action?pageId=807867493
  async confirmSelection(data) {
    return await requestFormPost(`/generic/mac/activityMaterial/confirmSelection`, data);
  },
};
